import type { MenuIcone } from "./types-planejamento-controle";

export const OUTLOOK_TITLE = "Controle do Outlook";
export const OUTLOOK_CARD_TOTAL_OBRA = "Total Obra";
export const OUTLOOK_CARD_SERVICOS = "Serviços";
export const OUTLOOK_CARD_MATERIAIS = "Materiais";
export const OUTLOOK_CARD_FACILIDADES = "Facilidades";
export const KPI_TOTAL = "Total";
export const KPI_NC = "NC";
export const KPI_CP = "CP";
export const EXCEDIDO_LABEL = "Excedido";
export const EXCEDIDO_ORIENTACAO =
  "Ajuste necessário: aumente a projeção ou reduza os custos estimados";

export const COTACAO_TITLE = "Cotação da Obra";
export const COTACAO_ESCOPO_NOTA = "Vale para todos os escopos e Facilidades desta Obra.";
export const COTACAO_EDITAR_LABEL = "Editar";
export const COTACAO_DEFINIR_LABEL = "Definir cotação";
/** MS05, texto único do card e do modal (HU 2479; doc do Figma 12341:483470, 30/10): a projeção grava na moeda original. */
export const COTACAO_PENDENTE_TITULO = (moeda: string) =>
  `Cotação ${moeda} não definida para esta Obra.`;
export const COTACAO_PENDENTE_NOTA = (moeda: string) =>
  `Só é possível cadastrar estimativas em ${moeda} após a definição da cotação.`;

export const TABELA_LABEL = "Tipos de Obra e Escopos macro";
export const COLUNA_NOME = "Tipos de Obra e Escopos macro";
export const COLUNA_CLASSIFICACAO = "Classificação";
export const COLUNA_TOTAL = "Total";
export const COLUNA_NC = "NC";
export const NO_VALUE = "—";
/** Unidade de exibição da Obra (`unidadeExibicao: "MILHOES"`). */
export const UNIDADE_MILHOES = { simbolo: "R$", sufixo: "MM" } as const;
export const ESCOPO_PENDENTE = "Pendente";
/** Figma 15597:1823190 (tag-sem-escopo): Tipo de Obra sem nenhum escopo macro. */
export const SEM_ESCOPO_MACRO = "Sem escopo macro";
/** Revisão da projeção e inclusão (Gustavo, HUs 2710 e 2712). */
export const AGUARDANDO_APROVACAO = "Aguardando aprovação";
/** Cancelamento e transferência (Figma 16312:675154). */
export const EM_APROVACAO = "Em aprovação";
/** Cancelamento de Tipo de Obra pendente (decisão F9 do Gustavo, HUs 2709 e 2717). */
export const CANCELAMENTO_AGUARDANDO_APROVACAO_TIPO = "Cancelamento aguardando aprovação";
/** Marcador no lugar do número da GMUD, até o Épico 30 trazê-lo. */
export const GMUD_NUMERO_MARCADOR = "----";
const gmud = (numero: string | null | undefined) => `GMUD ${numero || GMUD_NUMERO_MARCADOR}`;
const gmudAguardandoValidacao = (numero?: string | null) => `${gmud(numero)} aguardando validação.`;
/** MS08 (Figma 16312:675681 e 16316:429210): cancelamento e transferência do Escopo Macro. */
export const GMUD_ESCOPO_BLOQUEADO = (numero?: string | null) =>
  `${gmudAguardandoValidacao(numero)} Escopo Macro bloqueado para alterações.`;
/** MS07 (HU 2716), também na lista do modal Adicionar escopo (Figma 16720:470725). */
export const GMUD_TIPO_BLOQUEADO = (numero?: string | null) =>
  `${gmudAguardandoValidacao(numero)} Tipo de Obra bloqueado para alterações.`;
/** Inclusão de Tipo (Figma 16115:324198). */
export const GMUD_INCLUSAO_TIPO = (numero?: string | null) =>
  `${gmud(numero)} aberta para a inclusão deste Tipo de Obra.`;

export const ADICIONAR_LABEL = "Adicionar";
// Figma 15597:1822994 (2715, o mais recente); o 12956:274132 (2709) ainda diz sem "Novo".
export const ADICIONAR_NOVO_TIPO = "Novo Tipo de Obra";
export const ADICIONAR_NOVO_ESCOPO = "Novo Escopo Macro";
export const MENU_ESCOPO_EDITAR = "Editar Escopo";
export const MENU_ESCOPO_TRANSFERIR = "Transferir Escopo";
export const MENU_ESCOPO_CANCELAR = "Cancelar Escopo";
export const MENU_TIPO_TRANSFERIR = "Transferir Tipo de Obra";
export const MENU_TIPO_CANCELAR = "Cancelar Tipo de Obra";
export const MOTIVO_SEM_PERMISSAO_EDITAR = "Você não tem permissão para projetar custos.";
export const MOTIVO_REVISAO_PENDENTE = "Há uma revisão da projeção aguardando aprovação.";
export const MOTIVO_EDITAR_EM_FECHAMENTO =
  "Escopo em Fechamento: a projeção não pode mais ser editada.";
export const MOTIVO_EDITAR_SALDO_A_DESTINAR =
  "Escopo com saldo a destinar: destine o saldo antes de editar a projeção.";
export const MOTIVO_EDITAR_CANCELADO = "O escopo cancelado não pode ser editado.";
/** Figma dos menus ⋮ (Editar, Transferir, Cancelar); o menu Adicionar não tem ícones. O DS não tem arrow-right-arrow-left. */
export const ICONES_ACAO: Record<string, MenuIcone> = {
  editar: { ds: "pencil" },
  transferir: { prime: "pi pi-arrow-right-arrow-left" },
  cancelar: { ds: "times-circle" },
};
/** Colunas do modal Configuração da Tabela (Figma 16711:735430): todas travadas, porque a tabela é de cálculos. */
export const COLUNAS_CONFIGURACAO = ["nome", "classificacao", "total", "nc", "meses"] as const;
export type ColunaConfiguracao = (typeof COLUNAS_CONFIGURACAO)[number];
export const ROTULOS_COLUNAS_CONFIGURACAO: Record<ColunaConfiguracao, string> = {
  nome: COLUNA_NOME,
  classificacao: COLUNA_CLASSIFICACAO,
  total: COLUNA_TOTAL,
  nc: COLUNA_NC,
  meses: "Meses",
};
/** Tooltip das colunas travadas (Figma 16714:405602). */
export const COLUNAS_TRAVADAS_TOOLTIP =
  "Não é possível ocultar colunas. Todas são usadas nos cálculos da tabela.";

export const LUPA_LABEL = "Ver detalhes do escopo";
export const ACOES_LINHA_LABEL = "Mais ações";
export const EXPANDIR_LABEL = "Expandir";
export const RECOLHER_LABEL = "Recolher";

/** Tooltip dos botões de ícone: em cima e no hover, como a lupa das listagens do Hub (`HubTableDetailButton`). */
export const TOOLTIP_ICONE = { position: "top", event: "hover" } as const;

export const CARREGANDO_LABEL = "Carregando planejamento...";
export const VAZIO_TITLE = "Esta obra ainda não tem Tipos de Obra.";
export const VAZIO_DESCRIPTION = "Use Adicionar para incluir o primeiro Tipo de Obra.";
export const VAZIO_PENDENCIA_TITLE = "Os Tipos de Obra desta obra não puderam ser exibidos.";
export const VAZIO_PENDENCIA_DESCRIPTION =
  "Os Tipos de Obra existentes têm pendência de Centro de Custo. Resolva a pendência para vê-los aqui.";
export const PENDENCIAS_LABEL = "Pendências da obra";

/** Motivos do item "Novo Tipo de Obra" desabilitado (D-228), na ordem de precedência; frames Figma 17908:952408 (inativo), 17908:960140 (aguardando aprovação) e 16031:321460 (já tem todos); camadas de texto 17908:952417, 17908:960149 e 16031:1524609. */
export const MOTIVO_NOVO_TIPO_INATIVO =
  "Os Tipos de Obra que faltam estão inativos na Base de dados (Financeiro › Configurações).";
export const MOTIVO_NOVO_TIPO_EM_APROVACAO = "Os Tipos de Obra que faltam aguardam aprovação.";
export const MOTIVO_SEM_NOVO_TIPO = "A Obra já tem todos os Tipos de Obra disponíveis.";
/** Gustavo, HU 2713, 20/10: "nem incluir novos escopos". */
export const MOTIVO_ESCOPO_EM_FECHAMENTO =
  "Obra em Fechamento: não é possível incluir novos escopos.";
export const MOTIVO_SEM_PERMISSAO_ESCOPO = "Você não tem permissão para adicionar escopo macro.";
export const MOTIVO_SEM_PERMISSAO_TIPO = "Você não tem permissão para adicionar Tipo de Obra.";
export const MOTIVO_CANCELAMENTO_PENDENTE = GMUD_ESCOPO_BLOQUEADO();
export const MOTIVO_SEM_PERMISSAO_CANCELAR = "Você não tem permissão para cancelar este escopo.";
export const MOTIVO_SEM_PERMISSAO_CANCELAR_TIPO =
  "Você não tem permissão para cancelar este Tipo de Obra.";
export const MOTIVO_CANCELAMENTO_TIPO_PENDENTE = GMUD_TIPO_BLOQUEADO();
export const MOTIVO_TRANSFERENCIA_PENDENTE = GMUD_ESCOPO_BLOQUEADO();
export const MOTIVO_SEM_PERMISSAO_TRANSFERIR =
  "Você não tem permissão para transferir este escopo.";
export const MOTIVO_SEM_PERMISSAO_TRANSFERIR_TIPO =
  "Você não tem permissão para transferir este Tipo de Obra.";
export const MOTIVO_TRANSFERENCIA_TIPO_PENDENTE = GMUD_TIPO_BLOQUEADO();
export const MOTIVO_TIPO_SEM_ESCOPO = "Este Tipo de Obra não tem escopo macro para transferir.";

/** Exportar Visualização (Figma 16437:719044 e 16437:719011): nome base do arquivo quando o servidor não informa um. */
export const EXPORTACAO_FILE_NAME = "Planejamento e Controle";
export const EXPORTACAO_LIST_NAME = "Planejamento e Controle";

/** Figma 16777:492092 (escopo) e 17272:531042 (Tipo): aviso azul da confirmação com as duas Obras em FEL-0. */
export const AVISO_TRANSFERENCIA_FEL_ZERO =
  "As duas Obras estão no FEL 0: a transferência é feita na hora, sem aprovação.";
